import React, { useContext } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import { UserContext } from '@/context/userContext';
import { isUserInGroup } from '@/auth/EricksonAuthenticator';
import ExclusionRulesGrid from '@/components/ExclusionRulesGrid';

const ExclusionRulesPage: React.FC = () => {
  const userContext = useContext(UserContext);

  return userContext.user ? (
    isUserInGroup(userContext.user, 'Admin') ? (
      <Box ml={3} mr={3} mt={2}>
        <Typography variant="h2" mb={2} fontWeight={400}>
          Exclusion Rules
        </Typography>
        <Typography variant="body1" mb={2}>
          Exclusion rules are applied only to Bought List and House List
          exports. They do not affect the Opt Out page or reports.
        </Typography>
        <ExclusionRulesGrid />
      </Box>
    ) : (
      <div>Unauthorized</div>
    )
  ) : (
    <CircularProgress />
  );
};

export default ExclusionRulesPage;
